import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { withTheme } from 'styled-components'
import { Dropdown, Menu } from 'antd'
import Lottie from 'react-lottie'
import moment from 'moment'
import environment from '../../../environment'

import { Divider } from '../../Reusable/Input'

import { Text } from '../../Reusable/Text'
import { Image } from '../../Reusable/Image'
import { Flex, FlexColumn, CardContainer } from '../../Reusable/Container'
import { StyledExtLink, StyledLink } from '../../Reusable/Link'
import { Button, TextButton, ImageButton } from '../../Reusable/Button'
import { ErrorAlert } from '../../Reusable/Alert'
import { getBPAccountsWithAccess, getFeaturePerm } from '../../../Utils/util'
import { addDataToStore, SAVE_DATA, BNK_SAVE_DATA } from '../../../Actions/actions'
import { apiPOSTReq } from '../../../Utils/api'
import HighYieldAnimation from '../../Lotties/high-yield.json'

const HighYieldGSCard = (props) => {
    const [dropdownVisible, setDropdownVisible] = useState(false)
    const [selected, setSelected] = useState(false)
    const [loading, setLoading] = useState(false)
    const [hyaData, setHYAData] = useState()

    const { height, setShowCalculator } = props

    var Accounts = getBPAccountsWithAccess("Transactions", { getActiveAccounts: true })
    const instantPaymentsEnabled = getFeaturePerm("BusinessBanking.Payments.Instant Transfer")
    const internationalPaymentsEnabled = getFeaturePerm("BusinessBanking.Payments.International Transfer")
    Accounts = Accounts || []

    useEffect(() => {
        if (props.store.hyaData) setHYAData(props.store.hyaData)
        else getInterestRateInfo()
    }, [])

    useEffect(() => {
        var urlStr = props.location.search.replace('?', '');
        var action = (new URLSearchParams(urlStr).get('action') || '');
        if (action == "move_money") {
            setSelected(true)
        }
    }, [props.location.search])

    const getInterestRateInfo = () => {
        var body = {
            "FromDate": moment().format('YYYY-MM-DD'),
            "InterestRateType": "InterestPayout",
            "AccountNumber": "XXXX",
            "AccountType": "CHECKINGYIELD",
        }

        setLoading(true)
        console.log("HYA getInterestRateInfo", body)
        apiPOSTReq(`${environment.bbBaseUrl}/bb/getInterestRateInfo`, { "BankProvider": environment.bankProvider.crb }, body, (err, resp) => {
            try {
                const data = resp
                if (data.result) {
                    console.log("HYA getInterestRateInfo", resp)

                    const hyaData = {
                        hyaAPY: data.rateAPY,
                        fdicLink: data.fdicLink,
                        fdicAPY: data.fdicAPY,
                        fdicRate: data.fdicRate,
                        fdicEffectiveDate: data.fdicEffectiveDate,
                    }

                    setHYAData(hyaData)
                    props.dispatch(addDataToStore(SAVE_DATA, { hyaData }))
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                console.log("ERRR HYA getInterestRateInfo", error, err, resp)
                ErrorAlert({ description: error.message })
            } finally {
                setLoading(false)
            }
        })
    }

    return (

        <CardContainer
            padding='0'
            height={height || '388px'}
            style={{ marginLeft: 24, minWidth: 260, width: 260, zIndex: 10001 }}
        >
            <FlexColumn between left className="background-high-yield" style={{ padding: 24 }} fullWidth fullHeight>
                <FlexColumn start fullWidth fullHeight>
                    <div style={{ width: 64, height: 64 }}>
                        <Lottie
                            options={{
                                loop: true,
                                autoplay: true,
                                animationData: HighYieldAnimation,
                                rendererSettings: {
                                    preserveAspectRatio: "xMidYMid slice"
                                }
                            }}
                            height={64}
                            width={64}
                        />
                    </div>

                    <Text
                        size="24px"
                        weight="700"
                        margin="24px 0 8px"
                        width="200px"
                        height="32px"
                    >Earn more with Aion’s high yield account
                    </Text>

                    <Text height="24px">Maximize your earnings with {hyaData?.hyaAPY}% APY on your money. <StyledExtLink onClick={() => setShowCalculator(true)} style={{ textDecoration: "underline" }}>Learn more</StyledExtLink></Text>
                </FlexColumn>

                <Button text="Get started" onClick={() => props.history.push('/banking/high-yield-account')} />
            </FlexColumn>
        </CardContainer>
    )
}

function mapStateToProps(state) {
    return {
        store: state.aionAppReducer,
        bankingStore: state.bankingAppReducer
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTheme(HighYieldGSCard)))